import { Button as MuiButton, Tooltip } from '@mui/material';
import ViewInSalesforceDisabledIcon from './viewInSfDisabled.svg?react';
import ViewInSalesforceActiveIcon from './viewInSfActive.svg?react';
import { colors, Typography } from '@sweep-io/sweep-design';
import { ViewInSalesforce } from '@sweep-io/sweep-design/dist/icons';

export const ViewInSalesforceButton = ({
  viewInSalesforceLink,
  disabled,
}: {
  viewInSalesforceLink: string;
  disabled?: boolean;
}) => {
  //only used here - shouldn't be part of design system
  //coloring stroke is not working well with these icons therefore using two different icons
  const Icon = disabled ? ViewInSalesforceDisabledIcon : ViewInSalesforceActiveIcon;
  return (
    <Tooltip
      title={'Deploy your first model to view attribution data.'}
      placement="top"
      disableHoverListener={!disabled}
    >
      <span>
        <MuiButton
          disabled={disabled}
          variant="squared"
          size="small"
          sx={{
            background: disabled ? `${colors.grey[120]} !important` : colors.blue[100],
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'nowrap',
            height: '32px',
            borderRadius: '2px',
            borderColor: disabled ? colors.grey[500] : colors.blue[500],
          }}
          onClick={() => window.open(viewInSalesforceLink, '_blank')}
        >
          <Icon />{' '}
          <Typography variant="body-medium" color={disabled ? colors.grey[500] : colors.blue[500]}>
            View in Salesforce
          </Typography>{' '}
          <ViewInSalesforce color={disabled ? colors.grey[500] : colors.blue[500]} />
        </MuiButton>
      </span>
    </Tooltip>
  );
};
